
export enum PaymentMethodCd {
	BOTH = 'Both',
	COLL = 'Coll',
	PPD = 'Ppd'}

